import { Link } from 'types/layout';
import { NavigationLink } from 'types/header';

export const marketingLinks: Array<NavigationLink> = [
	{
		text: 'how it works',
		router: 'how-it-works'
	},
	{
		text: 'client returns',
		router: 'client-returns'
	},
	{
		dropdown: 'investments',
		links: [
			{
				text: 'general investing',
				router: 'investments'
			},
			{
				text: 'retirement investing',
				router: 'ira-landing'
			}
		]
	},
	{
		dropdown: 'strategy',
		links: [
			{
				text: 'overview',
				router: 'strategy'
			},
			{
				text: 'why real estate',
				router: 'why-private-real-estate'
			},
			{
				text: 'real estate strategies',
				router: 'real-estate-strategies'
			}
		]
	},
	{
		dropdown: 'resources',
		links: [
			{
				text: 'help & faqs',
				router: 'help-center-landing'
			},
			{
				text: 'education',
				router: 'blog-landing'
			}
		]
	}
];

export const settingsLinks: Array<Link> = [
	{
		text: 'Settings',
		router: 'settings-account-information-redirect'
	},
	{
		text: 'Log Out',
		router: 'logout-success'
	}
];
